// Geotab Service for handling technician location tracking
import { apiEndpoints } from '../config/env'
import { apiService } from './apiService'

export interface GeotabDevice {
  id: number
  dateCreated: string
  deviceID?: string
  deviceName?: string
  deviceSerialNumber?: string
  driverID?: string
  driverName?: string
  driverFirstName?: string
  driverLastName?: string
  deviceCurrentLatitude?: number
  deviceCurrentLongitude?: number
  deviceCurrentLogitude?: number // Backend typo - keeping for compatibility
}

class GeotabService {
  // Get current location for a technician by their driver name
  async getTechnicianLocation(technicianId: number): Promise<GeotabDevice | null> {
    try {
      return await apiService.get<GeotabDevice>(`${apiEndpoints.geotab.byTechnician(technicianId)}`)
    } catch (error) {
      console.error('Error fetching technician location:', error)
      return null
    }
  }

  // Get all geotab devices
  async getAllDevices(): Promise<GeotabDevice[]> {
    try {
      return await apiService.get<GeotabDevice[]>(apiEndpoints.geotab.all)
    } catch (error) {
      console.error('Error fetching geotab devices:', error)
      return []
    }
  }
}

export const geotabService = new GeotabService()
